import { Application } from '@hotwired/stimulus';

import ApplicationController from './university_portal/application_controller';
import NestedFormController from './university_portal/nested_form_controller';
import FormController from './university_portal/form_controller';
import RichTextController from './university_portal/rich_text_controller';
import ConfirmationModalController from './university_portal/confirmation_modal_controller';
import FiltersCloserController from './university_portal/filters_closer_controller';
import ProgramsFilterController from './university_portal/programs_filter_controller';
import ProgramsFilterPillsController from './university_portal/programs_filter_pills_controller';
import FetchWithTurboController from './university_portal/fetch_with_turbo_controller';
import HandlerController from './university_portal/handler_controller';
import UserController from './university_portal/user_menu_controller';
import ElementToggleableController from './shared/element_toggleable_controller';
import ElementVisibilityController from './shared/element_visibility_controller';
import SpinnerController from './university_portal/spinner_controller';
import FlashController from './shared/flash_controller';
import PasswordValidationsController from './shared/password_validations_controller';
import TurboStreamsController from './shared/turbo_streams_controller';
import SelectableColumnController from './university_portal/selectable_column_table_controller';
import TabsController from './university_portal/tabs_controller';
import ValidateInputController from './university_portal/validate_input';
import ValidateDecisionFormController from './university_portal/validate_decision_form';
import RecommendationSelectController from './university_portal/recommendation_select_controller';

const application = Application.start();
application.register('university-portal--application', ApplicationController);
application.register('university-portal--nested-form', NestedFormController);
application.register('university-portal--form', FormController);
application.register('university-portal--rich-text', RichTextController);
application.register('university-portal--confirmation-modal', ConfirmationModalController);
application.register('university-portal--filters-closer', FiltersCloserController);
application.register('university-portal--programs-filter', ProgramsFilterController);
application.register('university-portal--programs-filter-pills', ProgramsFilterPillsController);
application.register('university-portal--fetch-with-turbo', FetchWithTurboController);
application.register('university-portal--handler', HandlerController);
application.register('university-portal--user-menu', UserController);
application.register('university-portal--element-visibility', ElementVisibilityController);
application.register('shared--element-toggleable', ElementToggleableController);
application.register('university-portal--spinner', SpinnerController);
application.register('shared--flash', FlashController);
application.register('shared--password-validations', PasswordValidationsController);
application.register('turbo-streams', TurboStreamsController);
application.register('university-portal--selectable-column-table', SelectableColumnController);
application.register('university-portal--tabs', TabsController);
application.register('validate-input', ValidateInputController);
application.register('validate-decision-form', ValidateDecisionFormController);
application.register('university-portal--recommendation-select', RecommendationSelectController);
